// Service d'authentification PBP
import api from './api';
import { LoginRequest, LoginResponse, User } from '../types';

export const authService = {
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/auth/login/', credentials);
    const data = response.data;

    if (data.success && data.access) {
      localStorage.setItem('pbp_access_token', data.access);
      localStorage.setItem('pbp_refresh_token', data.refresh);
      localStorage.setItem('pbp_user', JSON.stringify(data.user));
    }

    return data;
  },

  async logout(): Promise<void> {
    const refresh = localStorage.getItem('pbp_refresh_token');
    try {
      await api.post('/auth/logout/', { refresh });
    } finally {
      localStorage.removeItem('pbp_access_token');
      localStorage.removeItem('pbp_refresh_token');
      localStorage.removeItem('pbp_user');
    }
  },

  async refreshToken(): Promise<string> {
    const refresh = localStorage.getItem('pbp_refresh_token');
    const response = await api.post('/auth/token/refresh/', { refresh });
    const { access } = response.data;
    localStorage.setItem('pbp_access_token', access);
    return access;
  },

  async getProfil(): Promise<User> {
    const response = await api.get('/users/moi/');
    return response.data.data;
  },

  async changerMotDePasse(data: {
    old_password: string;
    new_password: string;
    new_password_confirm: string;
  }): Promise<void> {
    await api.post('/auth/changer-mot-de-passe/', data);
  },

  getCurrentUser(): User | null {
    const user = localStorage.getItem('pbp_user');
    return user ? JSON.parse(user) : null;
  },

  isAuthenticated(): boolean {
    return !!localStorage.getItem('pbp_access_token');
  },

  getToken(): string | null {
    return localStorage.getItem('pbp_access_token');
  },
};
